export default __webpack_public_path__ + "static/media/Noyh.17822e04.ttf";